var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import paper from 'paper';
import { Injectable, NgZone } from '@angular/core';
import { EventName, Events } from '../../utils/events';
import { BaseProvider } from '../base';
import { ClassProvider } from '../class';
import { TaggableCanvasAsset } from '../../components/workspace/objects/taggableCanvasAsset';
import { Polygon } from '../../components/workspace/objects/polygon';
import { Collision } from '../../components/workspace/objects/collision';
import { NeuralaProject } from '../../components/workspace/objects/project';
import { SettingsProvider } from '../settings';
import { ModalProvider } from '../popup/modal';
import { RegionOfInterest } from '../../components/workspace/objects/region-of-interest';
import { GridLayer } from '../../components/workspace/objects/grid';
import { WorkspaceType } from '../workspace_enums';
import { MuteableModalProvider } from '../popup/muteable-modal';
import { TranslateService } from '@ngx-translate/core';
export var StackAction;
(function (StackAction) {
    StackAction["CREATE"] = "Create";
    StackAction["UPDATE"] = "Update";
    StackAction["DELETE"] = "Delete";
    StackAction["SET"] = "Set";
})(StackAction || (StackAction = {}));
export var SVG_TEXT_HEIGHT = 25;
export var SVG_TEXT_COORDINATES_WIDTH = 110;
export var SVG_TEXT_DIMENSIONS_WIDTH = 130;
var CanvasProvider = /** @class */ (function (_super) {
    __extends(CanvasProvider, _super);
    function CanvasProvider(classProvider, modalProvider, events, zone, settingsProvider, muteableModalProvider, translate) {
        var _this = _super.call(this) || this;
        _this.classProvider = classProvider;
        _this.modalProvider = modalProvider;
        _this.events = events;
        _this.zone = zone;
        _this.settingsProvider = settingsProvider;
        _this.muteableModalProvider = muteableModalProvider;
        _this.translate = translate;
        _this.ready = false;
        _this.locked = false;
        _this.allowUnsavedChangesEvent = true;
        _this.isDragging = true;
        _this.undoRedoStack = [];
        _this._hasUnsavedChanges = false;
        _this.currentStep = 0;
        _this.savedOnStep = 0;
        _this.polygonClipboard = [];
        _this.project = null;
        _this.initialCenter = null;
        _this.initialZoom = 1;
        _this.activePolygons = [];
        _this.activePolygonsIndex = {};
        _this.activeSegment = null;
        _this.activeImage = null;
        _this.hasOverlaps = false;
        _this.labelsEnabled = true;
        _this.predictionsEnabled = true;
        _this.wheelHandler = _this.handleWheelEvent.bind(_this);
        _this.scrollWheelEnabled = true;
        _this.shiftPressed = false;
        _this.tempRectangle = new paper.Rectangle(0, 0, 10, 10);
        _this.noClassColor = '#FFFFFF';
        _this.defaultClass = null;
        _this.roi = null;
        _this.originalROIPoints = null;
        _this.grid = null;
        _this.FLOATING_POINT_ERROR_THRESHOLD = 0.000001;
        _this.boundingBoxResizeSubscriptions = [];
        _this.initialBoxState = null; // Needed for a workaround when resizing bounding boxes
        return _this;
    }
    CanvasProvider.prototype.isReady = function () {
        return this.ready;
    };
    Object.defineProperty(CanvasProvider.prototype, "polygonMovingInProgress", {
        get: function () {
            if (this.project) {
                return this.project.polygonMovingInProgress;
            }
            else {
                return false;
            }
        },
        set: function (state) {
            if (this.project) {
                this.project.polygonMovingInProgress = state;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasProvider.prototype, "polygonResizingInProgress", {
        get: function () {
            if (this.project) {
                return this.project.polygonResizingInProgress;
            }
            else {
                return false;
            }
        },
        set: function (state) {
            if (this.project) {
                this.project.polygonResizingInProgress = state;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasProvider.prototype, "canRedo", {
        get: function () {
            return this.currentStep < this.undoRedoStack.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasProvider.prototype, "canUndo", {
        get: function () {
            return this.currentStep > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasProvider.prototype, "hasUnsavedChanges", {
        get: function () {
            return this._hasUnsavedChanges;
        },
        set: function (newValue) {
            this._hasUnsavedChanges = newValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CanvasProvider.prototype, "hasUnsavedChangesInROI", {
        get: function () {
            return this.roi && this.roi.hasChanges();
        },
        enumerable: true,
        configurable: true
    });
    CanvasProvider.prototype.updateUnsavedChangesFlag = function () {
        if (this.currentStep > this.savedOnStep) {
            for (var i = this.savedOnStep; i < this.currentStep; i++) {
                var stackItems = this.undoRedoStack[i];
                if (stackItems && stackItems.some(function (stackItem) { return stackItem && stackItem.saveable; })) {
                    this._hasUnsavedChanges = true;
                    return;
                }
            }
        }
        else if (this.currentStep < this.savedOnStep) {
            for (var i = this.currentStep - 1; i < this.savedOnStep; i++) {
                var stackItems = this.undoRedoStack[i];
                if (stackItems && stackItems.some(function (stackItem) { return stackItem && stackItem.saveable; })) {
                    this._hasUnsavedChanges = true;
                    return;
                }
            }
        }
        this._hasUnsavedChanges = false;
    };
    CanvasProvider.prototype.hasROI = function () {
        return this.roi !== null && this.roi.isDefined();
    };
    CanvasProvider.prototype.canDeleteROI = function () {
        return this.roi !== null && this.roi.canDelete();
    };
    CanvasProvider.prototype.getROI = function () {
        return this.roi;
    };
    CanvasProvider.prototype.getGrid = function () {
        return this.grid;
    };
    CanvasProvider.prototype.deleteROI = function () {
        if (this.roi) {
            this.roi.drawArea();
        }
    };
    CanvasProvider.prototype.toggleROIVisibility = function (visibility) {
        if (this.roi) {
            this.roi.visible = visibility;
        }
    };
    CanvasProvider.prototype.exportROI = function () {
        if (!this.roi || !this.roi.isDefined()) {
            return null;
        }
        return [
            this.normalizePointToArray(this.roi.getBounds().topLeft),
            this.normalizePointToArray(this.roi.getBounds().bottomLeft),
            this.normalizePointToArray(this.roi.getBounds().topRight),
            this.normalizePointToArray(this.roi.getBounds().bottomRight)
        ];
    };
    CanvasProvider.prototype.isROIBiggerThan = function (size, roi) {
        var asset = this.getAsset();
        if (!asset) {
            return false;
        }
        var xCoords = roi.map(function (point) { return point[0]; });
        var yCoords = roi.map(function (point) { return point[1]; });
        var minX = Math.min.apply(Math, xCoords);
        var maxX = Math.max.apply(Math, xCoords);
        var minY = Math.min.apply(Math, yCoords);
        var maxY = Math.max.apply(Math, yCoords);
        var width = (maxX - minX) * asset.width;
        var height = (maxY - minY) * asset.height;
        return width >= size && height >= size;
    };
    CanvasProvider.prototype.convertPolygonToROI = function (polygon) {
        var _a = polygon.getPoints(this.normalizePoint.bind(this)).reduce(function (acc, currentValue) {
            return currentValue.reduce(function (innerAcc, currentValue) {
                var x1 = innerAcc[0], x2 = innerAcc[1], y1 = innerAcc[2], y2 = innerAcc[3];
                return [
                    x1 > currentValue[0] ? currentValue[0] : x1,
                    x2 < currentValue[0] ? currentValue[0] : x2,
                    y1 > currentValue[1] ? currentValue[1] : y1,
                    y2 < currentValue[1] ? currentValue[1] : y2
                ];
            }, acc);
        }, [Infinity, -Infinity, Infinity, -Infinity]), x1 = _a[0], x2 = _a[1], y1 = _a[2], y2 = _a[3];
        return [
            [x1, y1],
            [x1, y2],
            [x2, y1],
            [x2, y2]
        ];
    };
    CanvasProvider.prototype.markROIAsSaved = function () {
        if (this.roi) {
            this.roi.markAsSaved();
        }
    };
    CanvasProvider.prototype.initializeROI = function (points) {
        if (points === void 0) { points = null; }
        if (this.roi) {
            return;
        }
        var originalROIPoint = null;
        var originalROISize = null;
        this.originalROIPoints = points;
        if (points) {
            var denormalizedPoints = this.denormalize(points);
            // This may be undefined if the the asset/view/canvas is missing
            // In that case we just abort
            if (denormalizedPoints === undefined) {
                return;
            }
            var roiRectangle = new paper.Path(denormalizedPoints);
            originalROIPoint = roiRectangle.bounds.point.clone();
            originalROISize = roiRectangle.bounds.size.clone();
        }
        else {
            originalROIPoint = new paper.Point(0, 0);
            originalROISize = new paper.Size(0, 0);
        }
        this.roi = new RegionOfInterest(originalROIPoint, originalROISize);
    };
    CanvasProvider.prototype.drawROI = function (points) {
        if (points === void 0) { points = null; }
        if (!this.roi) {
            this.initializeROI(this.originalROIPoints);
        }
        var project = this.getProject();
        if (!project) {
            return;
        }
        if (this.roi) {
            if (points) {
                var denormalizedPoints = this.denormalize(points);
                // This might happen if the asset/view/canvas is missing
                // In that case, let's just abort
                if (!denormalizedPoints) {
                    return;
                }
                var roiRectangle = new paper.Path(denormalizedPoints);
                roiRectangle.closed = true;
                this.roi.visible = true;
                this.roi.drawArea(roiRectangle.bounds.point, roiRectangle.bounds.size);
            }
            else {
                this.roi.drawArea();
                this.roi.visible = false;
            }
            this.roi.addTo(project);
            this.roi.bringToFront();
        }
    };
    CanvasProvider.prototype.resetInfo = function () {
        this.reset();
    };
    CanvasProvider.prototype.setLockState = function (state) {
        if (state === void 0) { state = false; }
        this.locked = state;
    };
    CanvasProvider.prototype.setCursor = function (cursor) {
        if (cursor === void 0) { cursor = 'default'; }
        var canvas = this.getCanvas();
        if (canvas) {
            canvas.style.cursor = cursor;
        }
    };
    CanvasProvider.prototype.emitSaveableChange = function () {
        if (this.allowUnsavedChangesEvent) {
            this.events.publish(EventName.CanvasSaveableChange);
        }
    };
    CanvasProvider.prototype.markAllItemsAsSaved = function () {
        this.savedOnStep = this.currentStep;
        this.updateUnsavedChangesFlag();
    };
    /***********************
     *  Undo/Redo Methods  *
     **********************/
    CanvasProvider.prototype.clearUndoStack = function () {
        this.undoRedoStack = [];
        this.currentStep = 0;
        this.savedOnStep = 0;
        this.updateUnsavedChangesFlag();
    };
    CanvasProvider.prototype.clearRedoStack = function () {
        this.undoRedoStack.splice(this.currentStep);
        if (this.savedOnStep > this.currentStep) {
            this.savedOnStep = 0;
        }
        this.currentStep = this.undoRedoStack.length;
        this.updateUnsavedChangesFlag();
    };
    CanvasProvider.prototype.revertAllChanges = function () {
        while (this.currentStep - this.savedOnStep != 0) {
            if (this.currentStep > this.savedOnStep) {
                this.undoSingleStackAction();
            }
            else {
                this.redoSingleStackAction();
            }
        }
        this.detectCollisions();
        this.updateUnsavedChangesFlag();
    };
    CanvasProvider.prototype.undo = function () {
        if (this.currentStep <= 0) {
            return;
        }
        this.undoSingleStackAction();
        this.detectCollisions();
        this.updateUnsavedChangesFlag();
    };
    CanvasProvider.prototype.undoSingleStackAction = function () {
        this.currentStep--;
        var stackItems = this.undoRedoStack[this.currentStep];
        if (!stackItems || stackItems.length == 0) {
            return;
        }
        var newStates = this.performStackActions(stackItems);
        this.undoRedoStack[this.currentStep] = newStates;
    };
    CanvasProvider.prototype.redo = function () {
        this.redoSingleStackAction();
        this.detectCollisions();
        this.updateUnsavedChangesFlag();
    };
    CanvasProvider.prototype.redoSingleStackAction = function () {
        if (this.currentStep >= this.undoRedoStack.length) {
            return;
        }
        var stackItems = this.undoRedoStack[this.currentStep];
        this.currentStep++;
        if (!stackItems || stackItems.length == 0) {
            this.updateUnsavedChangesFlag();
            return;
        }
        var newStates = this.performStackActions(stackItems);
        this.undoRedoStack[this.currentStep - 1] = newStates;
    };
    CanvasProvider.prototype.performStackActions = function (stackItems) {
        var _this = this;
        var result = [];
        stackItems.forEach(function (stackItem) {
            var actionResult = _this.performStackAction(stackItem);
            if (actionResult) {
                result.push(actionResult);
            }
        });
        return result;
    };
    /**
     * Creates a stack item for undo/redo stack
     *
     * @param {StackAction} action Performed action: CREATE, UPDATE, DELETE
     * @param {Polygon[]} polygons List of polygons affected by the change
     * @param {boolean} willClosePolygon Set to true in case change you apply will close the polygons
     */
    CanvasProvider.prototype.createStackItem = function (action, polygons, willClosePolygon) {
        if (willClosePolygon === void 0) { willClosePolygon = false; }
        return this.generateNewStackItem(action, polygons, willClosePolygon);
    };
    CanvasProvider.prototype.addToUndoStack = function (stackItems) {
        var stackItemsToAdd = stackItems.filter(function (stackItem) { return stackItem.polygons && stackItem.polygons.length > 0; });
        if (stackItemsToAdd.length <= 0) {
            return;
        }
        this.clearRedoStack();
        this.undoRedoStack.push(stackItems);
        this.currentStep = this.undoRedoStack.length;
        this.updateUnsavedChangesFlag();
    };
    /**
     * Removes polygon from the historical records, so there is no way to restore it
     * @param {Polygon} polygonToForget
     */
    CanvasProvider.prototype.removePolygonFromHistory = function (polygonToForget) {
        var newStack = [];
        // build new undo/redo stack which does not have a polygon
        this.undoRedoStack.forEach(function (stackItems) {
            var newStackItems = [];
            stackItems.forEach(function (stackItem) {
                var polygons = stackItem.polygons.filter(function (polygon) { return polygon.id !== polygonToForget.id; });
                if (polygons.length > 0) {
                    newStackItems.push(Object.assign({}, stackItem, { polygons: polygons }));
                }
            });
            if (newStackItems.length > 0) {
                newStack.push(newStackItems);
            }
        });
        // after we have a new stack we need to adjust currentStep and savedOnStep flags
        var oldLength = this.undoRedoStack.length;
        var newLength = newStack.length;
        var diff = oldLength - newLength;
        this.currentStep -= diff;
        this.savedOnStep -= diff;
        this.undoRedoStack = newStack;
    };
    /*
     * Creates a stack item for undo/redo stack
     *
     * @param {StackAction} action Performed action: CREATE, UPDATE, DELETE
     * @param {Polygon[]} polygons List of polygons affected by the change
     * @param {boolean} willClosePolygon Set to true in case change you apply will close the polygons
     */
    CanvasProvider.prototype.generateNewStackItem = function (action, polygons, willClosePolygon) {
        if (willClosePolygon === void 0) { willClosePolygon = false; }
        var stackItem = {
            action: action,
            polygons: polygons.map(function (polygon) { return polygon.clone(); }),
            saveable: polygons.some(function (polygon) { return !!polygon.neuralaClass.id && (polygon.closed || willClosePolygon); })
        };
        return stackItem;
    };
    /**
     * Given a StackAction, determine what
     * the opposite action should be
     * So for example, if you created a polygon
     * and hit "Undo" the opposite action would
     * be to delete the polygon
     */
    CanvasProvider.prototype.getInverseAction = function (action) {
        switch (action) {
            case StackAction.CREATE:
                return StackAction.DELETE;
            case StackAction.UPDATE:
                return StackAction.UPDATE;
            case StackAction.DELETE:
                return StackAction.CREATE;
            case StackAction.SET:
                return StackAction.SET;
            default:
                return null;
        }
    };
    /**
     * Given a StackItem
     * executes the instructions contained
     * within that object
     *
     * Returns an action to "undo" the action that was just done
     */
    CanvasProvider.prototype.performStackAction = function (item) {
        var _this = this;
        var polygonsIndex = {};
        var polygonIDs = [];
        if (!item || !item.polygons) {
            return null;
        }
        item.polygons.forEach(function (polygon, i) {
            polygonsIndex[polygon.id] = i;
            polygonIDs.push(polygon.id);
        });
        var actionToPerform = this.getInverseAction(item.action);
        var polygonsToAlter = this.getAllChildren().filter(function (polygon) { return polygonIDs.includes(polygon.id); });
        var project = this.getProject();
        if (!project) {
            return null;
        }
        var reverseState = null;
        switch (actionToPerform) {
            case StackAction.CREATE:
                reverseState = this.generateNewStackItem(actionToPerform, item.polygons.slice());
                item.polygons.forEach(function (polygon) {
                    polygon.addTo(project);
                    if (polygon.fullySelected) {
                        _this.addActivePolygon(polygon);
                    }
                    else {
                        _this.clearActivePolygon(polygon);
                    }
                });
                break;
            case StackAction.UPDATE:
                reverseState = this.generateNewStackItem(actionToPerform, polygonsToAlter);
                polygonsToAlter.forEach(function (polygon) {
                    var stackPolygon = item.polygons[polygonsIndex[polygon.id]];
                    var isActive = _this.isPolygonActive(polygon);
                    if (reverseState && stackPolygon.neuralaClass.id !== null) {
                        reverseState.saveable = true;
                    }
                    _this.removePolygon(polygon);
                    stackPolygon.addTo(project);
                    if (isActive) {
                        _this.addActivePolygon(stackPolygon);
                    }
                    else {
                        _this.clearActivePolygon(stackPolygon);
                    }
                });
                break;
            case StackAction.DELETE:
                reverseState = this.generateNewStackItem(actionToPerform, polygonsToAlter);
                polygonsToAlter.forEach(function (polygon) { return _this.removePolygon(polygon); });
                break;
            case StackAction.SET:
                reverseState = this.generateNewStackItem(actionToPerform, this.getAllPolygons());
                this.getAllPolygons().forEach(function (polygon) {
                    _this.removePolygon(polygon);
                });
                item.polygons.forEach(function (polygon) {
                    polygon.addTo(project);
                    if (polygon.fullySelected) {
                        _this.addActivePolygon(polygon);
                    }
                    else {
                        _this.clearActivePolygon(polygon);
                    }
                });
                break;
            default:
                break;
        }
        return reverseState;
    };
    /********************
     *  Getter Methods  *
     *******************/
    CanvasProvider.prototype.getScope = function () {
        return this.scope;
    };
    CanvasProvider.prototype.getProject = function () {
        return this.project;
    };
    CanvasProvider.prototype.getAsset = function () {
        return this.asset;
    };
    CanvasProvider.prototype.isAssetVisible = function () {
        return this.asset !== null && this.asset.visible;
    };
    CanvasProvider.prototype.getCanvas = function () {
        var view = this.getView();
        if (view) {
            return view.element;
        }
        else {
            return null;
        }
    };
    CanvasProvider.prototype.getView = function () {
        var project = this.getProject();
        if (project) {
            return project.view;
        }
        return null;
    };
    CanvasProvider.prototype.getActiveAsset = function () {
        return this.activeImage;
    };
    /*************
     * Utilities *
     ************/
    CanvasProvider.prototype.setScrollWheelStatus = function (status) {
        this.scrollWheelEnabled = status;
    };
    CanvasProvider.prototype.shiftIsDown = function () {
        return this.shiftPressed;
    };
    /* NOTE: This is a stopgap to allow workspace provider development.
     * Having this allows us to remove most keyboard event listeners and return to
     * the problem when the workspace provider is more mature.
     */
    CanvasProvider.prototype.setShiftIsDown = function (state) {
        this.shiftPressed = state;
    };
    /***********
     *  Image  *
     **********/
    CanvasProvider.prototype.setAssetVisibility = function (status) {
        if (status === void 0) { status = true; }
        var asset = this.getAsset();
        if (asset) {
            asset.visible = status;
        }
    };
    /**
     * If a point is near the boundary of an image, snap the point to the boundary
     * otherwise leave the point alone
     */
    CanvasProvider.prototype.snapToImageIfNecessary = function (point) {
        var image = this.getAsset();
        var TOLERANCE = 7;
        var payload = {
            snap: false,
            point: point
        };
        if (!image) {
            return payload;
        }
        if (Math.abs(point.x - image.bounds.topLeft.x) <= TOLERANCE) {
            payload.snap = true;
            payload.point.x = image.bounds.topLeft.x;
        }
        if (Math.abs(point.x - image.bounds.bottomRight.x) <= TOLERANCE) {
            payload.snap = true;
            payload.point.x = image.bounds.bottomRight.x;
        }
        if (Math.abs(point.y - image.bounds.topLeft.y) <= TOLERANCE) {
            payload.snap = true;
            payload.point.y = image.bounds.topLeft.y;
        }
        if (Math.abs(point.y - image.bounds.bottomRight.y) <= TOLERANCE) {
            payload.snap = true;
            payload.point.y = image.bounds.bottomRight.y;
        }
        return payload;
    };
    /************************
     *  Polygon Management  *
     ***********************/
    CanvasProvider.prototype.isPolygonActive = function (polygon) {
        return Number.isInteger(this.activePolygonsIndex[polygon.id]);
    };
    CanvasProvider.prototype.updatePolygonClass = function (classObject) {
        return this.getAllChildren()
            .filter(function (item) { return item.neuralaType == 'Polygon' && item.closed && item.neuralaClass.id; })
            .forEach(function (polygon) {
            if (polygon.neuralaClass.id == classObject.id) {
                polygon.assignClass(classObject);
                polygon.visible = !(classObject.visible === false);
            }
        });
    };
    CanvasProvider.prototype.deletePolygonsForClass = function (classObject) {
        var _this = this;
        this.getAllChildren()
            .filter(function (item) { return item.neuralaType == 'Polygon' && item.closed && item.neuralaClass.id; })
            .forEach(function (polygon) {
            if (polygon.neuralaClass.id == classObject.id) {
                _this.removePolygon(polygon);
            }
        });
    };
    CanvasProvider.prototype.assignClass = function (polygon, classObject, isPrediction) {
        if (isPrediction === void 0) { isPrediction = false; }
        if (isPrediction) {
            polygon.markClassAsPredicted();
        }
        else {
            polygon.markClassAsNotPredicted();
        }
        if (polygon.neuralaClass.id == classObject.id) {
            return;
        }
        var stackItem = this.createStackItem(StackAction.UPDATE, [polygon]);
        stackItem.saveable = polygon.closed ? true : false;
        this.addToUndoStack([stackItem]);
        polygon.assignClass(classObject);
        this.emitSaveableChange();
    };
    CanvasProvider.prototype.createPolygon = function (layers, fullySelected) {
        if (fullySelected === void 0) { fullySelected = true; }
        var project = this.getProject();
        if (!project) {
            return;
        }
        var polygon = new Polygon({
            children: layers.map(function (layer) { return new paper.Path(layer); }),
            closed: true,
            fullySelected: fullySelected
        });
        polygon.addTo(project);
        return polygon;
    };
    CanvasProvider.prototype.removePolygon = function (polygonToRemove) {
        var polygonLocation = this.activePolygonsIndex[polygonToRemove.id];
        if (Number.isInteger(polygonLocation)) {
            this.activePolygons.splice(polygonLocation, 1);
            this.calculateActivePolygonsIndex();
        }
        if (polygonToRemove.closed && polygonToRemove.neuralaClass.id) {
            this.emitSaveableChange();
        }
        polygonToRemove.remove();
        // temo solution
        // TODO: refactor this when history management will be moved out of canvas provider
        this.events.publish(EventName.CanvasPolygonRemoved);
    };
    CanvasProvider.prototype.getAllChildren = function () {
        var project = this.getProject();
        if (!project || !project.activeLayer) {
            return [];
        }
        return project.activeLayer.children;
    };
    CanvasProvider.prototype.resetAllChildren = function () {
        var project = this.getProject();
        if (project && project.activeLayer) {
            project.activeLayer.children = [];
        }
    };
    /**
     * Fill in the polygon external ids if they aren't already set
     * This relies on the fact that brainbank will return the identifiers
     * in the order it gets the polygons.
     */
    CanvasProvider.prototype.updatePolygonExternalIds = function (polygonExternalIds) {
        this.getPolygonsWithClasses().forEach(function (polygon) {
            if (!polygon.polygonIdentifier) {
                polygon.polygonIdentifier = polygonExternalIds[polygon.id];
            }
        });
    };
    CanvasProvider.prototype.removeAllPolygons = function () {
        var _this = this;
        this.getAllChildren()
            .filter(function (item) { return item.neuralaType == 'Polygon'; })
            .slice(0)
            .forEach(function (polygon) { return _this.removePolygon(polygon); });
    };
    CanvasProvider.prototype.export = function (filterFn) {
        var _this = this;
        if (filterFn === void 0) { filterFn = null; }
        var defaultExportFilteringFunction = function (item) {
            return item.neuralaType == 'Polygon' && item.closed && item.neuralaClass.id;
        };
        return this.getAllChildren()
            .filter(filterFn || defaultExportFilteringFunction)
            .map(function (polygon) {
            return Object.assign(polygon.export(), {
                data: polygon.getPoints(_this.normalizePoint.bind(_this))
            });
        });
    };
    CanvasProvider.prototype.exportForRedraw = function () {
        var polygons = this.getAllPolygons();
        return this.convertToExportedPolygons(polygons);
    };
    CanvasProvider.prototype.convertToExportedPolygons = function (polygons) {
        var _this = this;
        return polygons.map(function (polygon) {
            return Object.assign(polygon.exportForRedraw(), {
                data: polygon.getPoints(_this.normalizePoint.bind(_this))
            });
        });
    };
    CanvasProvider.prototype.getAllPolygons = function () {
        return this.getAllChildren().filter(function (item) { return item.neuralaType == 'Polygon'; }) || [];
    };
    CanvasProvider.prototype.getClosedPolygons = function () {
        return this.getAllChildren().filter(function (item) { return item.neuralaType == 'Polygon' && item.closed && item.visible; }) || [];
    };
    CanvasProvider.prototype.getPolygonsWithClasses = function () {
        return this.getAllChildren().filter(function (item) { return item.neuralaType == 'Polygon' && item.neuralaClass.id; }) || [];
    };
    CanvasProvider.prototype.getPolygonsWithoutClasses = function () {
        return this.getAllChildren().filter(function (item) { return item.neuralaType == 'Polygon' && !item.neuralaClass.id; }) || [];
    };
    CanvasProvider.prototype.canSubtractPolygons = function () {
        return this.getClosedPolygons().length > 0;
    };
    CanvasProvider.prototype.calculateActivePolygonsIndex = function () {
        var _this = this;
        this.activePolygonsIndex = {};
        this.getActivePolygons().forEach(function (polygon, i) {
            _this.activePolygonsIndex[polygon.id] = i;
        });
    };
    // Remove a polygon from the active stack
    CanvasProvider.prototype.clearActivePolygon = function (polygon) {
        var location = this.activePolygonsIndex[polygon.id];
        if (!Number.isInteger(location)) {
            return this.getActivePolygons();
        }
        if (this.activePolygons[location].isBoundingBox) {
            this.stopTrackingBoundingBoxResize(polygon.id);
        }
        this.activePolygons[location].deactivate();
        this.activePolygons.splice(location, 1);
        this.calculateActivePolygonsIndex();
        return this.getActivePolygons();
    };
    // Clears ALL polygons from the active stack
    CanvasProvider.prototype.clearActivePolygons = function () {
        var _this = this;
        var activePolygons = this.getActivePolygons();
        activePolygons.forEach(function (polygon) {
            if (polygon.isBoundingBox) {
                _this.stopTrackingBoundingBoxResize(polygon.id);
            }
            if (!_this.isPolygonAScaleTool(polygon)) {
                polygon.deactivate();
            }
        });
        this.activePolygons = [];
        this.activePolygonsIndex = {};
    };
    // Clears and deleted ALL active polygons
    CanvasProvider.prototype.removeActivePolygons = function () {
        var activePolygons = this.getActivePolygons();
        activePolygons.forEach(function (polygon) {
            polygon.remove();
        });
        this.clearRedoStack();
        this.activePolygons = [];
        this.activePolygonsIndex = {};
        if (activePolygons.length > 0) {
            this.emitSaveableChange();
        }
        // TODO: refactor this when history management will be moved out of canvas provider
        this.events.publish(EventName.CanvasPolygonRemoved);
    };
    // Add a polygon to the active stack
    CanvasProvider.prototype.addActivePolygon = function (newPolygon) {
        var location = this.activePolygonsIndex[newPolygon.id];
        if (!Number.isInteger(location)) {
            this.activePolygons.push(newPolygon);
            this.activePolygonsIndex[newPolygon.id] = this.activePolygons.length - 1;
        }
        newPolygon.activate();
        if (newPolygon.isBoundingBox) {
            this.startTrackingBoundingBoxResize(newPolygon.id);
        }
        return this.getActivePolygons();
    };
    CanvasProvider.prototype.isPolygonAScaleTool = function (polygon) {
        return polygon && polygon.name != null;
    };
    CanvasProvider.prototype.setDefaultClass = function (classObj) {
        this.defaultClass = classObj;
    };
    CanvasProvider.prototype.validateListOfPolygons = function (polygons) {
        for (var _i = 0, polygons_1 = polygons; _i < polygons_1.length; _i++) {
            var polygon = polygons_1[_i];
            if (!(polygon instanceof Polygon)) {
                return false;
            }
        }
        return true;
    };
    // Set the active polygons, clearing out any old ones
    CanvasProvider.prototype.setActivePolygons = function (polygons) {
        var _this = this;
        if (!this.shiftPressed && this.validateListOfPolygons(polygons)) {
            this.clearActivePolygons();
        }
        polygons.forEach(function (polygon) {
            if (polygon instanceof Polygon) {
                if (_this.shiftPressed) {
                    // shift-clicking a polygon toggles whether it is selected or not
                    if (_this.activePolygonsIndex[polygon.id] === undefined) {
                        // the polygon isn't selected, so we select it
                        _this.activePolygons.push(polygon);
                    }
                    else {
                        // the polygon is selected and we need to deselect it
                        polygon.deactivate();
                        _this.activePolygons.splice(_this.activePolygonsIndex[polygon.id], 1);
                        delete _this.activePolygonsIndex[polygon.id];
                    }
                }
                else {
                    _this.activePolygons.push(polygon);
                }
            }
        });
        this.activePolygons.forEach(function (polygon, i) {
            if (!_this.isPolygonAScaleTool(polygon) && polygon instanceof Polygon) {
                if ((!polygon.closed || !polygon.neuralaClass || !polygon.neuralaClass.id) && _this.defaultClass) {
                    _this.assignClass(polygon, _this.defaultClass);
                }
                polygon.activate();
                _this.activePolygonsIndex[polygon.id] = i;
                if (polygon.isBoundingBox) {
                    _this.startTrackingBoundingBoxResize(polygon.id);
                }
            }
        });
        return this.getActivePolygons();
    };
    CanvasProvider.prototype.getActivePolygons = function () {
        return this.activePolygons;
    };
    CanvasProvider.prototype.getMutatingPolygons = function () {
        return this.activePolygons.filter(function (polygon) { return polygon.isResizing; });
    };
    CanvasProvider.prototype.getClipboardPolygons = function () {
        return this.polygonClipboard;
    };
    CanvasProvider.prototype.setClipboardPolygons = function (polygons) {
        this.polygonClipboard = polygons;
    };
    CanvasProvider.prototype.clearClipboardPolygons = function () {
        this.polygonClipboard = [];
    };
    /**
     * If drawing with a pen, background cut, or foreground cut, we need to determine
     * when it makes sense to autoclose the polygon instead of adding a new point
     */
    CanvasProvider.prototype.shouldAutoClose = function (point, polygon) {
        var project = this.getProject();
        if (!project) {
            return false;
        }
        var AUTO_CLOSE_THRESHOLD = 20 / project.view.zoom;
        return point.getDistance(polygon.getOuterContour().getPointAt(0)) < AUTO_CLOSE_THRESHOLD;
    };
    /**
     * Run a method without triggering a change event
     */
    CanvasProvider.prototype.runWithoutTriggeringChangeEvent = function (callback) {
        this.allowUnsavedChangesEvent = false;
        callback.bind(this)();
        this.allowUnsavedChangesEvent = true;
    };
    CanvasProvider.prototype.clearPolygons = function () {
        var _this = this;
        this.runWithoutTriggeringChangeEvent(function () {
            _this.removeAllPolygons();
        });
    };
    /**
     * Adjust the coordinates of the active polygons slightly (accounting for boundaries)
     * On views that support it (segmentation and object detection), this allows users
     * to move selected polygons a few pixels at a time by pressing arrow keys.
     * @param {string} direction The direction in which the polygon(s) should move
     * @param {number} amount The amount of pixels that the polygons(s) should move.
     */
    CanvasProvider.prototype.nudgeSelectedPolygons = function (direction, amount) {
        var _this = this;
        var currentlySelectedPolygons = this.getActivePolygons();
        var newCoordinatesDelta = { x: 0, y: 0 };
        var canDoAllMoves = true;
        switch (direction) {
            case 'up':
                newCoordinatesDelta.y = -amount;
                break;
            case 'down':
                newCoordinatesDelta.y = amount;
                break;
            case 'left':
                newCoordinatesDelta.x = -amount;
                break;
            case 'right':
                newCoordinatesDelta.x = amount;
                break;
        }
        // Make sure users don't nudge the polygons out of bounds of image
        currentlySelectedPolygons.forEach(function (polygon) {
            var polygonNewBounds = new paper.Rectangle({
                x: polygon.bounds.x + newCoordinatesDelta.x,
                y: polygon.bounds.y + newCoordinatesDelta.y,
                width: polygon.bounds.width,
                height: polygon.bounds.height
            });
            if (!_this.inBoundsRectangle(polygonNewBounds)) {
                canDoAllMoves = false;
            }
        });
        if (canDoAllMoves) {
            currentlySelectedPolygons.forEach(function (polygon) {
                polygon.position.x += newCoordinatesDelta.x;
                polygon.position.y += newCoordinatesDelta.y;
                if (polygon.isBoundingBox) {
                    polygon.updateBoundingBoxTools();
                }
                if (polygon.neuralaClass.id) {
                    _this.emitSaveableChange();
                }
                var stackItem = _this.createStackItem(StackAction.UPDATE, _this.getActivePolygons());
                _this.addToUndoStack([stackItem]);
            });
            this.detectCollisions();
        }
    };
    CanvasProvider.prototype.pasteCurrentPolygons = function (currentWorkspaceType) {
        var _this = this;
        var asset = this.getAsset();
        if (!asset) {
            return;
        }
        this.clearActivePolygons();
        var canvasBounds = asset.bounds;
        var undoStackItems = [];
        var shouldEmitSaveableChangeEvent = false;
        var currentPolygons = this.getAllPolygons();
        var newPolygons = this.getClipboardPolygons();
        if (currentWorkspaceType === WorkspaceType.ObjectDetection) {
            var boundingBoxesOnly = newPolygons.filter(function (polygon) { return polygon.isBoundingBox; });
            if (boundingBoxesOnly.length < newPolygons.length) {
                // If we have a mixture of polygons and bounding boxes,
                // filter out the polygons, and try to paste just the bounding boxes.
                newPolygons = boundingBoxesOnly.slice(); // Spread to prevent referencing issues
                this.modalProvider.presentError(this.translate.instant('Cannot Paste Copied Polygons'), this.translate.instant('You cannot paste polygons onto Detection images. Please use the bounding box tool to classify objects within the image.'), undefined, this.translate.instant('Okay'));
                if (newPolygons.length === 0) {
                    return;
                }
            }
        }
        var doesAllFit = newPolygons.every(function (_a) {
            var bounds = _a.bounds;
            return bounds.right <= canvasBounds.right &&
                bounds.left >= canvasBounds.left &&
                bounds.top >= canvasBounds.top &&
                bounds.bottom <= canvasBounds.bottom;
        });
        if (!doesAllFit) {
            this.modalProvider.presentError(this.translate.instant('Cannot Paste Copied Polygons'), this.translate.instant('Some of the copied polygons will not fit on the current image. Please make sure that the source and destination images have similar dimensions.'), undefined, this.translate.instant('Okay'));
            return;
        }
        newPolygons.forEach(function (value) {
            var newPolygon = value.clone();
            newPolygon.polygonIdentifier = undefined;
            newPolygon.isBoundingBox = value.isBoundingBox;
            if (newPolygon.hasNeuralaClass() && !shouldEmitSaveableChangeEvent) {
                shouldEmitSaveableChangeEvent = true;
            }
            // Figure out where to nudge the new polygon(s).
            // If the new location would be outside the image, wrap to the other side of the image.
            var newPosition = {
                x: newPolygon.position.x,
                y: newPolygon.position.y
            };
            var shouldNudge = currentPolygons.some(function (_a) {
                var position = _a.position, bounds = _a.bounds;
                return position.x === newPolygon.position.x &&
                    position.y === newPolygon.position.y &&
                    bounds.width === newPolygon.bounds.width &&
                    bounds.height === bounds.height;
            });
            if (shouldNudge) {
                newPosition.x =
                    newPolygon.bounds.right + 10 > canvasBounds.right
                        ? canvasBounds.left + newPolygon.bounds.width / 2
                        : newPosition.x + 10;
                newPosition.y =
                    newPolygon.bounds.bottom + 10 > canvasBounds.bottom
                        ? canvasBounds.top + newPolygon.bounds.height / 2
                        : newPosition.y + 10;
                newPolygon.position.x = newPosition.x;
                newPolygon.position.y = newPosition.y;
                // In order to keep nudging, we need to adjust the positions of the stored clipboard polygons as well
                value.position.x = newPosition.x;
                value.position.y = newPosition.y;
            }
            var project = _this.getProject();
            if (!project) {
                return;
            }
            // We also need to generate a new ID property for the new polygon and make sure it doesn't clash with other IDs.
            newPolygon.setId(Math.max.apply(Math, [0].concat(_this.getAllPolygons().map(function (value) { return value.id; }))) + 1);
            newPolygon.addTo(project);
            _this.addActivePolygon(newPolygon);
            undoStackItems.push(newPolygon);
            // Defensive logic to ensure bounding boxes render properly
            if (newPolygon.isBoundingBox) {
                newPolygon.generateBoundingBoxManipulationTools();
                newPolygon.bbManipulationTools.forEach(function (tool) {
                    tool.obj.addTo(project);
                });
            }
        });
        var stackItem = this.createStackItem(StackAction.CREATE, undoStackItems);
        this.addToUndoStack([stackItem]);
    };
    CanvasProvider.prototype.selectAllPolygons = function () {
        var _this = this;
        var project = this.getProject();
        if (!project) {
            return;
        }
        var allPolygons = this.getAllPolygons();
        allPolygons.forEach(function (polygon) {
            _this.addActivePolygon(polygon);
            if (polygon.isBoundingBox) {
                // Defensive logic to ensure bounding boxes render properly
                polygon.generateBoundingBoxManipulationTools();
                polygon.bbManipulationTools.forEach(function (tool) {
                    tool.obj.addTo(project);
                });
            }
        });
    };
    CanvasProvider.prototype.deleteSelectedPolygons = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentActivePolygons, shouldDelete;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentActivePolygons = this.getActivePolygons();
                        if (!(currentActivePolygons.length > 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.muteableModalProvider.presentDeleteBulkPolygonsPrompt()];
                    case 1:
                        shouldDelete = _a.sent();
                        if (shouldDelete) {
                            this.continueDeletion(currentActivePolygons);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.continueDeletion(currentActivePolygons);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CanvasProvider.prototype.continueDeletion = function (currentActivePolygons) {
        if (currentActivePolygons.length > 0) {
            var stackItem = this.createStackItem(StackAction.DELETE, currentActivePolygons);
            this.addToUndoStack([stackItem]);
            this.removeActivePolygons();
            this.detectCollisions();
        }
    };
    /**
     * Store the currently selected polygons in our polygon clipboard, allowing users to later paste them elsewhere.
     * Any existing polygons in the clipboard are overwritten.
     */
    CanvasProvider.prototype.copySelectedPolygons = function () {
        var currentActivePolygons = this.getActivePolygons();
        if (currentActivePolygons.length > 0) {
            this.setClipboardPolygons(currentActivePolygons.map(function (polygon) { return polygon.clone(); }));
        }
    };
    // In order to ensure users can undo bounding box resizes, we need to listen to events emitted
    // directly from the bounding box, starting when the user selects it.
    CanvasProvider.prototype.startTrackingBoundingBoxResize = function (index) {
        var _this = this;
        var activePolygons = this.getActivePolygons();
        if (activePolygons && activePolygons.length > 0) {
            var boxToTrack_1 = activePolygons[this.activePolygonsIndex[index]];
            // Before tracking, we should make sure we haven't already subscribed
            // to the resize event (which could otherwise happen if a user clicks
            // a bounding box handle multiple times without resizing).
            var boxIsNotBeingTracked = !this.boundingBoxResizeSubscriptions.find(function (subscription) { return subscription.index === index; });
            if (boxToTrack_1 && boxIsNotBeingTracked) {
                // If all is well, create the subscription.
                var resizeSubscription = boxToTrack_1.boundingBoxResizeInProgress.subscribe(function (data) {
                    if (data === true) {
                        _this.initialBoxState = _this.createStackItem(StackAction.UPDATE, [boxToTrack_1]);
                    }
                    else if (data === false) {
                        if (!_this.initialBoxState) {
                            return;
                        }
                        _this.addToUndoStack([_this.initialBoxState]);
                        _this.initialBoxState = null;
                    }
                });
                this.boundingBoxResizeSubscriptions.push({
                    index: index,
                    subscription: resizeSubscription
                });
            }
        }
    };
    // When a user deselects a bounding box, stop listening for resize events.
    CanvasProvider.prototype.stopTrackingBoundingBoxResize = function (index) {
        var boxToStopTracking = this.boundingBoxResizeSubscriptions.findIndex(function (subscription) { return subscription.index === index; });
        if (boxToStopTracking >= 0) {
            this.boundingBoxResizeSubscriptions[boxToStopTracking].subscription.unsubscribe();
            this.boundingBoxResizeSubscriptions.splice(boxToStopTracking, 1);
        }
    };
    /*************
     *  Segment  *
     ************/
    CanvasProvider.prototype.setActiveSegment = function (segment) {
        this.activeSegment = segment;
        return this.getActiveSegment();
    };
    CanvasProvider.prototype.getActiveSegment = function () {
        return this.activeSegment;
    };
    CanvasProvider.prototype.clearActiveSegment = function () {
        this.setActiveSegment(null);
    };
    CanvasProvider.prototype.removeActiveSegment = function () {
        var activeSegment = this.getActiveSegment();
        if (activeSegment) {
            activeSegment.remove();
            this.clearActiveSegment();
        }
    };
    /*************************
     *  Viewport Management  *
     ************************/
    /**
     * Returns point which is inside asset
     * @param {paper.Point} point Project point
     */
    CanvasProvider.prototype.adjustPointToAssetBounds = function (point) {
        var project = this.getProject();
        if (!project) {
            return;
        }
        if (project.layers['assetLayer'].contains(point)) {
            return point;
        }
        var bounds = project.layers['assetLayer'].bounds;
        var newX = point.x;
        var newY = point.y;
        if (newX < bounds.left) {
            newX = bounds.left;
        }
        else if (newX > bounds.right) {
            newX = bounds.right;
        }
        if (newY < bounds.top) {
            newY = bounds.top;
        }
        else if (newY > bounds.bottom) {
            newY = bounds.bottom;
        }
        return new paper.Point(newX, newY);
    };
    /**
     * This method is used only in marquee tool.
     * TODO: revisit marquee tool (task has already been added to JIRA)
     */
    CanvasProvider.prototype.adjustPointToBounds = function (x, y) {
        var project = this.getProject();
        if (!project) {
            return;
        }
        var viewPoint = project.view.viewToProject(new paper.Point(x, y));
        var asset = this.getAsset();
        if (!asset) {
            return;
        }
        var bounds = asset.bounds;
        var newX = viewPoint.x;
        var newY = viewPoint.y;
        if (newX < bounds.left) {
            newX = bounds.left;
        }
        else if (newX > bounds.right) {
            newX = bounds.right;
        }
        if (newY < bounds.top) {
            newY = bounds.top;
        }
        else if (newY > bounds.bottom) {
            newY = bounds.bottom;
        }
        return new paper.Point(newX, newY);
    };
    CanvasProvider.prototype.adjustPointToBoundsAndCanvas = function (x, y) {
        var canvas = this.getCanvas();
        if (!canvas) {
            return;
        }
        var rect = canvas.getBoundingClientRect();
        var point = this.adjustPointToBounds(x - rect.left, y - rect.top);
        if (!point) {
            return;
        }
        if (this.grid && this.grid.visible) {
            point = this.grid.adjustPointToGrid(point);
        }
        return point;
    };
    // Ensure user cannot draw outside of the image bounds
    CanvasProvider.prototype.inBounds = function (point) {
        var asset = this.getAsset();
        if (!asset) {
            return false;
        }
        return (point.x >= asset.bounds.left &&
            point.x <= asset.bounds.right &&
            point.y >= asset.bounds.top &&
            point.y <= asset.bounds.bottom);
    };
    /**
     * Ensures a specified rectangle is
     * completely within bounds of the asset
     */
    CanvasProvider.prototype.inBoundsRectangle = function (rect) {
        var asset = this.getAsset();
        if (!asset) {
            return false;
        }
        return asset.bounds.contains(rect);
    };
    /**
     * Tests the proposed new values of a bounding box to ensure it will be valid.
     * This function tests the proposed values without creating a new polygon for every test.
     *
     * @param {number} x Transformed x value
     * @param {number} y Transformed y value
     * @param {number} width New width
     * @param {number} height New height
     * @returns {boolean} valid bounding box
     * @memberof CanvasProvider
     */
    CanvasProvider.prototype.willBeValidBoundingBox = function (x, y, width, height) {
        this.tempRectangle.set(x, y, width, height);
        return this.inBoundsRectangle(this.tempRectangle);
    };
    CanvasProvider.prototype.viewIsZoomedOut = function (zoom) {
        if (zoom === void 0) { zoom = null; }
        if (!this.project) {
            return false;
        }
        var view = this.project.view;
        if (!view) {
            return false;
        }
        return view.zoom.toFixed(2) == this.initialZoom.toFixed(2);
    };
    CanvasProvider.prototype.changeZoom = function (event, scaleFactor) {
        if (scaleFactor === void 0) { scaleFactor = 1.075; }
        var project = this.getProject();
        if (!project) {
            return false;
        }
        var viewPosition = project.view.viewToProject(new paper.Point(event.layerX, event.layerY));
        var oldZoom = project.view.zoom;
        var center = project.view.center;
        var newZoom = event.deltaY * -1 > 0 ? oldZoom * scaleFactor : oldZoom / scaleFactor;
        var zoomScale = oldZoom / newZoom;
        var pointerPositionMinusViewCenter = viewPosition.subtract(center);
        var centerTranslationVector = viewPosition
            .subtract(pointerPositionMinusViewCenter.multiply(zoomScale))
            .subtract(center);
        var didSetZoom = this.setZoom(newZoom);
        if (didSetZoom) {
            // If user zooms all the way out, let's recenter the image
            if (this.viewIsZoomedOut(project.view.zoom)) {
                this.setCenter(this.initialCenter);
            }
            else {
                this.setCenter(project.view.center.add(centerTranslationVector));
            }
        }
        for (var _i = 0, _a = this.activePolygons; _i < _a.length; _i++) {
            var polygon = _a[_i];
            if (polygon.isBoundingBox) {
                polygon.updateBoundingBoxTools();
            }
        }
        event.stopPropagation();
        return false;
    };
    CanvasProvider.prototype.setZoom = function (zoom) {
        var project = this.getProject();
        var view = this.getView();
        if (!view || !project) {
            return false;
        }
        if (zoom < this.initialZoom) {
            zoom = this.initialZoom;
        }
        else if (zoom > 999) {
            zoom = 999;
        }
        if (zoom != project.view.zoom) {
            project.view.zoom = zoom;
            this.scope.settings.hitTolerance = 3 / view.zoom;
            this.events.publish(EventName.CanvasZoomChanged);
            return true;
        }
        else {
            return false;
        }
    };
    CanvasProvider.prototype.changeCenter = function (event) {
        var project = this.getProject();
        if (!project) {
            return false;
        }
        var factor = 1 / project.view.zoom;
        var oldCenter = project.view.center;
        var offset = new paper.Point(event.deltaX, event.deltaY);
        offset = offset.multiply(factor);
        var newCenter = oldCenter.add(offset);
        this.setCenter(newCenter);
        event.preventDefault();
        return false;
    };
    // Ensures that a user does not pan out of bounds of the image
    CanvasProvider.prototype.clampCenter = function (center) {
        var asset = this.getAsset();
        var view = this.getView();
        if (!asset || !center || !view) {
            return null;
        }
        var viewSize = view.size;
        var imageBounds = asset.bounds;
        if (!imageBounds || !viewSize) {
            return null;
        }
        if (!this.initialCenter) {
            return null;
        }
        if (view.center.y - viewSize.height / 2 <= imageBounds.top &&
            view.center.y + viewSize.height / 2 >= imageBounds.bottom) {
            center.y = this.initialCenter.y;
        }
        else {
            var topBound = center.y - viewSize.height / 2;
            if (topBound < imageBounds.top) {
                var diff = Math.abs(topBound - imageBounds.top);
                center.y += diff;
            }
            var bottomBound = center.y + viewSize.height / 2;
            if (bottomBound > imageBounds.bottom) {
                var diff = Math.abs(bottomBound - imageBounds.bottom);
                center.y -= diff;
            }
        }
        if (view.center.x - viewSize.width / 2 <= imageBounds.left &&
            view.center.x + viewSize.width / 2 >= imageBounds.right) {
            center.x = this.initialCenter.x;
        }
        else {
            var leftBound = center.x - viewSize.width / 2;
            if (leftBound < imageBounds.left) {
                var diff = Math.abs(leftBound - imageBounds.left);
                center.x += diff;
            }
            var rightBound = center.x + viewSize.width / 2;
            if (rightBound > imageBounds.right) {
                var diff = Math.abs(rightBound - imageBounds.right);
                center.x -= diff;
            }
        }
        return center;
    };
    CanvasProvider.prototype.setCenter = function (center) {
        if (this.viewIsZoomedOut()) {
            center = this.initialCenter;
        }
        if (!center) {
            return;
        }
        center = this.clampCenter(center);
        if (!center) {
            return;
        }
        var newCenterX = center.x.toFixed(3);
        var newCenterY = center.y.toFixed(3);
        var project = this.getProject();
        if (!project) {
            return;
        }
        var currentCenterX = project.view.center.x.toFixed(3);
        var currentCenterY = project.view.center.y.toFixed(3);
        if (newCenterX != currentCenterX || newCenterY != currentCenterY) {
            project.view.center = center;
        }
    };
    /** When zoomed into an asset, move the user's view by the passed in amount of pixels.
     * This definition allows components to call a prebaked nudge function
     * without worrying about how it's implemented.
     * @param x How many pixels we should move the view horizontally.
     * @param y How many pixels we should move the view vertically.
     */
    CanvasProvider.prototype.nudgeView = function (x, y) {
        var view = this.getView();
        if (!view) {
            return;
        }
        this.setCenter(view.center.add(new paper.Point(x, y)));
    };
    /** When zoomed into an asset, pan the image so that it's centered within the canvas.
     * This is used to improve the behavior of the zoom input text fields.
     * We do lose any panning inside the image, though.
     */
    CanvasProvider.prototype.resetViewToCenter = function () {
        this.setCenter(this.initialCenter);
    };
    /**
     * Find the x value needed to center a DOM element within the canvas area
     */
    CanvasProvider.prototype.getCenteredPointOverCanvas = function (element, xPercent, yPercent) {
        if (xPercent === void 0) { xPercent = 0.5; }
        if (yPercent === void 0) { yPercent = 0.5; }
        var rect = element.getBoundingClientRect();
        var canvas = this.getCanvas();
        if (!canvas) {
            return;
        }
        var canvasRect = canvas.getBoundingClientRect();
        var x = canvasRect.width * xPercent - rect.width / 2;
        var y = canvasRect.height * yPercent - rect.height / 2;
        return [x, y];
    };
    CanvasProvider.prototype.positionElementInCanvasWithPixels = function (element, x, y) {
        element.style.transform = "translate(" + x + "px, " + y + "px)";
    };
    /**
     * Adjust the element to keep it visible in canvas
     * If element is adjusted, return the new coordinates
     */
    CanvasProvider.prototype.keepElementVisibleWithinCanvas = function (element) {
        var canvas = this.getCanvas();
        if (!canvas) {
            return;
        }
        var rect = element.getBoundingClientRect();
        var canvasRect = canvas.getBoundingClientRect();
        if (rect.width >= canvasRect.width) {
            return;
        }
        if (rect.height >= canvasRect.height) {
            return;
        }
        var x = null;
        var y = null;
        var adjust = false;
        if (rect.left < canvasRect.left) {
            x = 0;
            y = rect.top - canvasRect.top;
            adjust = true;
        }
        else if (rect.right > canvasRect.right) {
            x = canvasRect.right - canvasRect.left - rect.width;
            y = rect.top - canvasRect.top;
            adjust = true;
        }
        else if (rect.bottom > canvasRect.bottom) {
            x = rect.left - canvasRect.left;
            y = canvasRect.bottom - canvasRect.top - rect.height;
            adjust = true;
        }
        if (adjust && x && y) {
            this.positionElementInCanvasWithPixels(element, x, y);
            return [x, y];
        }
        else {
            return undefined;
        }
    };
    CanvasProvider.prototype.applyGridSettings = function (state) {
        if (state === void 0) { state = null; }
        if (this.grid && state) {
            this.grid.setColor(state.color);
            if (state.visible) {
                this.grid.show();
            }
            else {
                this.grid.hide();
            }
            this.grid.drawLayer(state.columns, state.rows);
        }
    };
    /***********
     *  Setup  *
     **********/
    CanvasProvider.prototype.setActiveAsset = function (image) {
        return __awaiter(this, void 0, void 0, function () {
            var project, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        project = this.getProject();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.ready = false;
                        this.resetViewToCenter();
                        this.clearUndoStack();
                        this.setZoom(1);
                        this.activeImage = image;
                        if (project) {
                            this.initialCenter = project.view.center.clone();
                        }
                        else {
                            this.initialCenter = null;
                        }
                        return [4 /*yield*/, this.redraw()];
                    case 2:
                        _a.sent();
                        this.ready = true;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CanvasProvider.prototype.loadImage = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var activeAsset;
            return __generator(this, function (_a) {
                activeAsset = this.getActiveAsset();
                if (!activeAsset) {
                    return [2 /*return*/];
                }
                if (!this.getProject()) {
                    return [2 /*return*/];
                }
                /**
                 * If crossOrigin is not specified during initialization, paperjs
                 * throws a fit during resizing (cross-origin tainting error)
                 */
                this.asset = new TaggableCanvasAsset({
                    crossOrigin: 'anonymous',
                    source: activeAsset.url
                });
                this.asset.addTo(this.assetLayer);
                this.asset.visible = false;
                this.asset.onLoad = function () {
                    var project = _this.getProject();
                    if (project) {
                        _this.asset.fitBounds(project.view.bounds, false);
                    }
                    _this.asset.sourceRaster = _this.asset.clone({ insert: false });
                    _this.asset.visible = true;
                    return resolve();
                };
                this.asset.onError = function (e) {
                    return reject(e);
                };
                return [2 /*return*/];
            });
        }); });
    };
    CanvasProvider.prototype.normalizePoint = function (point) {
        var image = this.asset;
        var relativePosition = point.subtract(image.bounds.point);
        // Round the point to 5 decimal places
        return new paper.Point(Math.round((100000 * relativePosition.x) / (image.width * image.getScaling().x)) / 100000, Math.round((100000 * relativePosition.y) / (image.height * image.getScaling().y)) / 100000);
    };
    CanvasProvider.prototype.denormalizePoint = function (point) {
        var asset = this.getAsset();
        if (!asset) {
            return;
        }
        var view = this.getView();
        if (!view) {
            return;
        }
        return new paper.Point(point.x * (asset.width * asset.scaling.x * view.zoom) + view.projectToView(asset.bounds.point).x, point.y * (asset.height * asset.scaling.y * view.zoom) + view.projectToView(asset.bounds.point).y);
    };
    CanvasProvider.prototype.getAssetScale = function () {
        var asset = this.getAsset();
        if (!asset) {
            return;
        }
        return { x: asset.scaling.x, y: asset.scaling.y };
    };
    /**
     * Helper function for Region of Interest
     */
    CanvasProvider.prototype.normalizePointToArray = function (point) {
        var result = this.normalizePoint(point);
        return [result.x, result.y];
    };
    CanvasProvider.prototype.denormalize = function (contour) {
        var denormalizedPoints = [];
        for (var _i = 0, contour_1 = contour; _i < contour_1.length; _i++) {
            var point = contour_1[_i];
            /**
             * To denormalize a point, multiply it by the image dimensions * the zoom level
             * Additionally, since the image is centered we need to offset the points by how much the image has been shifted over/down;
             */
            var denormalizedPoint = this.denormalizePoint(new paper.Point(point[0], point[1]));
            if (!denormalizedPoint) {
                return;
            }
            var project = this.getProject();
            if (project) {
                denormalizedPoints.push(project.view.viewToProject(denormalizedPoint));
            }
        }
        return denormalizedPoints;
    };
    CanvasProvider.prototype.normalize = function (contour) {
        var _this = this;
        var project = this.getProject();
        if (!project) {
            return;
        }
        return contour.map(function (point) {
            return project.view.viewToProject(_this.normalizePoint(new paper.Point(point[0], point[1])));
        });
    };
    /**
     * Given a normalized width and height value on the canvas, return an absolute point on the reference frame of the original image
     * Some values are coming from a place where they are already normalized for the current zoom value.  If this is
     * the case, don't try to normalize them again
     */
    CanvasProvider.prototype.getAbsoluteDimensions = function (width, height, alreadyZoomNormalized) {
        var asset = this.getAsset();
        var view = this.getView();
        if (!asset || !view) {
            return;
        }
        var xAbs = width / asset.scaling.x;
        var yAbs = height / asset.scaling.y;
        if (!alreadyZoomNormalized) {
            xAbs = xAbs / view.zoom;
            yAbs = yAbs / view.zoom;
        }
        return new paper.Point(Math.round(xAbs), Math.round(yAbs));
    };
    /**
     * Returns an "absolute" set of coordinates of a single point on an image, regardless of scaling or zoom factor.
     * The returned paper.Point is normalized, but the "origin" is the top-left of the image itself and not the canvas
     */
    CanvasProvider.prototype.getAbsoluteCoordinatesFromViewPoint = function (x, y, alreadyZoomNormalized) {
        var asset = this.getAsset();
        var view = this.getView();
        if (!asset || !view) {
            return;
        }
        var viewPoint = new paper.Point(x, y);
        var assetPoint = view.projectToView(asset.bounds.point);
        return this.getAbsoluteDimensions(viewPoint.x - assetPoint.x, viewPoint.y - assetPoint.y, alreadyZoomNormalized);
    };
    CanvasProvider.prototype.getAbsoluteCoordinates = function (x, y, alreadyZoomNormalized) {
        var view = this.getView();
        if (!view) {
            return;
        }
        var viewPoint = view.projectToView(new paper.Point(x, y));
        return this.getAbsoluteCoordinatesFromViewPoint(viewPoint.x, viewPoint.y, alreadyZoomNormalized);
    };
    CanvasProvider.prototype.getPolygonDimensionsText = function (polygon) {
        var absolutePoint = this.getAbsoluteDimensions(polygon.bounds.width, polygon.bounds.height, true);
        if (absolutePoint) {
            return this.getDimensionsText(absolutePoint.x, absolutePoint.y);
        }
        else {
            return '';
        }
    };
    CanvasProvider.prototype.getROIDimensionsText = function (roi) {
        var absolutePoint = this.getAbsoluteDimensions(roi.getWidth(), roi.getHeight(), true);
        if (absolutePoint) {
            return this.getDimensionsText(absolutePoint.x, absolutePoint.y);
        }
        else {
            return '';
        }
    };
    CanvasProvider.prototype.getDimensionsText = function (width, height) {
        return "W: " + width + "px, H: " + height + "px";
    };
    CanvasProvider.prototype.getCoordinatesText = function (x, y) {
        return "X: " + x + ", Y: " + y;
    };
    /**
     * Determines whether there is room in some direction of the asset for an element of dimensions width x height
     * from position x/y without overflowing the asset.
     *
     * The incoming coordinates here should be relative to the canvas, which starts at 0,0 on the top-left
     *
     * @param x The x-coordinate of the point from which to check if there is room
     * @param y The y-coordinate of the point from which to check if there is room
     * @param roomWidth The width of the element that starts from x
     * @param roomHeight The height of the element that starts from y
     * @returns AssetRoom
     */
    CanvasProvider.prototype.getAssetRoomFromCanvasContext = function (x, y, roomWidth, roomHeight) {
        var assetRect = this.getAssetBoundingClientRect();
        if (!assetRect) {
            return {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
        }
        return {
            left: x - roomWidth >= assetRect.x,
            right: x + roomWidth <= assetRect.x + assetRect.width,
            top: y - assetRect.y >= roomHeight,
            bottom: y + roomHeight <= assetRect.y + assetRect.height
        };
    };
    /**
     * Determines whether there is room in some direction of the asset for an element of dimensions width x height
     * from position x/y without overflowing the asset.
     *
     * We convert the view-context coordinates to canvas-context coordinates, adjusting for zoom.  FYI the coordinates
     * are already adjusted for scaling.
     *
     * For example: the ROI-tool-provided coordinates are relative to the asset.
     *  However, if we are zoomed in and panned around, we need to still know where the actual edge of the canvas is.
     *
     * @param x The x-coordinate of the point from which to check if there is room
     * @param y The y-coordinate of the point from which to check if there is room
     * @param roomWidth The width of the element that starts from x
     * @param roomHeight The height of the element that starts from y
     * @returns AssetRoom
     */
    CanvasProvider.prototype.getAssetRoomFromViewContext = function (x, y, roomWidth, roomHeight) {
        var view = this.getView();
        if (!view) {
            return {
                left: false,
                right: false,
                top: false,
                bottom: false
            };
        }
        var canvasX = (x - view.bounds.x) * view.zoom;
        var canvasY = (y - view.bounds.y) * view.zoom;
        return this.getAssetRoomFromCanvasContext(canvasX, canvasY, roomWidth, roomHeight);
    };
    CanvasProvider.prototype.generateChildren = function (contours) {
        var _this = this;
        var children = [];
        if (!!contours) {
            contours.forEach(function (contour) {
                var denormalizedPoints = _this.denormalize(contour);
                if (!denormalizedPoints) {
                    return;
                }
                children.push(new paper.Path({ segments: denormalizedPoints, closed: true }));
            });
        }
        return children;
    };
    /**
     * Get Polygons list
     */
    CanvasProvider.prototype.getPolygons = function (rawPolygons) {
        if (rawPolygons === void 0) { rawPolygons = null; }
        var polygons = rawPolygons || this.getActiveAssetPolygons();
        if (!polygons) {
            return [];
        }
        return this.createPolygons(polygons);
    };
    CanvasProvider.prototype.createPolygons = function (polygons) {
        var _this = this;
        return polygons.map(function (polygon) {
            // Create a new polygon object and assign a class to it
            var classObject = _this.classProvider.getClassByID(polygon.classIdentifier);
            var newPolygon = new Polygon({
                children: _this.generateChildren(polygon.data),
                fullySelected: false,
                polygonIdentifier: polygon.polygonIdentifier,
                insert: false,
                neuralaClass: polygon.neuralaClass ? polygon.neuralaClass : classObject,
                visible: !classObject || classObject.visible !== false,
                defaultNoClassColor: _this.noClassColor,
                prediction: polygon.prediction || null
            });
            if (polygon.predictionFlag) {
                newPolygon.markClassAsPredicted();
            }
            if (polygon.clientIdentifier) {
                newPolygon.setId(polygon.clientIdentifier);
            }
            return newPolygon;
        });
    };
    CanvasProvider.prototype.getActiveAssetPolygons = function () {
        var activeAsset = this.getActiveAsset();
        if (activeAsset && activeAsset.polygons) {
            return activeAsset.polygons;
        }
        return [];
    };
    /**
     * Load Polygons list and add to current project
     */
    CanvasProvider.prototype.loadPolygons = function (polygons) {
        var loadedPolygons = this.getPolygons(polygons);
        if (this.project) {
            for (var _i = 0, loadedPolygons_1 = loadedPolygons; _i < loadedPolygons_1.length; _i++) {
                var polygon = loadedPolygons_1[_i];
                polygon.addTo(this.project);
            }
        }
        return loadedPolygons;
    };
    CanvasProvider.prototype.reset = function () {
        if (this.project) {
            this.project.clear();
        }
        this.originalROIPoints = null;
        this.roi = null;
        this.grid = null;
        this.clearUndoStack();
        this.activeImage = null;
        this.clearActiveSegment();
        this.clearActivePolygons();
        this._hasUnsavedChanges = false;
    };
    CanvasProvider.prototype.init = function (canvas, workspaceType) {
        var _this = this;
        if (canvas) {
            this.canvas = canvas;
        }
        if (this.canvas) {
            this.canvas.removeEventListener('wheel', this.wheelHandler, true);
            this.canvas.addEventListener('wheel', this.wheelHandler, true);
            this.canvas.oncontextmenu = function (e) {
                var view = _this.getView();
                if (view) {
                    var point = view.viewToProject(new paper.Point(e.offsetX, e.offsetY));
                    return !_this.inBounds(point);
                }
                else {
                    return false;
                }
            };
        }
        this.scope = new paper.PaperScope();
        this.scope.settings.handleSize = 7;
        this.scope.settings.hitTolerance = 3;
        this.project = new NeuralaProject(this.canvas);
        this.project.events = this.events;
        this.project.setCursor = this.setCursor.bind(this);
        // Order of layers is important
        // polygons must be on top of all other layers
        this.assetLayer = new paper.Layer({ name: 'assetLayer' });
        this.grid = new GridLayer({ name: 'gridLayer', active: false, selected: false, locked: true });
        this.polygonsLayer = new paper.Layer({
            name: 'polygons',
            active: true,
            selected: true
        });
        this.polygonsLayer.addTo(this.project);
        this.grid.addTo(this.project);
        var extendedView = this.project.view;
        // Extend the paperjs update method to link with angular change detection
        this.project.view.update = function () {
            if (!_this.project) {
                return false;
            }
            if (!extendedView._needsUpdate) {
                return false;
            }
            var extendedProject = _this.project;
            var viewContext = extendedView._context;
            var size = _this.project.view.viewSize;
            viewContext.clearRect(0, 0, size.width + 1, size.height + 1);
            if (extendedProject) {
                _this.zone.run(function () {
                    if (_this.project) {
                        extendedProject.draw(viewContext, _this.project.view.matrix, _this.project.view.pixelRatio);
                    }
                });
            }
            extendedProject._needsUpdate = false;
            return true;
        };
    };
    /********************
     *  Event Handlers  *
     *******************/
    CanvasProvider.prototype.handleWheelEvent = function (event) {
        if (!this.ready || !this.scrollWheelEnabled || this.locked) {
            return;
        }
        if (!event.shiftKey) {
            if (Math.abs(event.deltaY) > 1) {
                this.changeZoom(event);
            }
        }
        else if (event.shiftKey) {
            this.changeCenter(event);
        }
    };
    // Need to re-activate active polygons/segments
    // Need to regenerate undo/redo stack
    CanvasProvider.prototype.redraw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var polygons, normalizedClipboardPolygons, hasROI, roiPoints, roiWasChanged, canvas, gridState, activePolygonsIndex_1, _a, newWidth, newHeight, err_2, zoom, center;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        polygons = this.exportForRedraw();
                        normalizedClipboardPolygons = this.convertToExportedPolygons(this.polygonClipboard);
                        hasROI = this.roi ? true : false;
                        roiPoints = this.exportROI();
                        roiWasChanged = this.roi && this.roi.hasChanges();
                        canvas = this.getCanvas();
                        gridState = null;
                        if (this.grid) {
                            gridState = {
                                columns: this.grid.getColumns(),
                                rows: this.grid.getRows(),
                                visible: this.grid.visible,
                                color: this.grid.getColor()
                            };
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.ready = false;
                        if (this.initialCenter) {
                            this.setCenter(this.initialCenter);
                        }
                        this.setZoom(this.initialZoom);
                        activePolygonsIndex_1 = this.activePolygonsIndex;
                        if (this.polygonsLayer) {
                            this.polygonsLayer.removeChildren();
                        }
                        if (this.assetLayer) {
                            this.assetLayer.removeChildren();
                        }
                        if (this.roi && hasROI) {
                            this.roi.remove();
                        }
                        if (canvas && this.project) {
                            _a = canvas.getBoundingClientRect(), newWidth = _a.width, newHeight = _a.height;
                            this.project.view.viewSize = new paper.Size(newWidth, newHeight);
                        }
                        this.clearActiveSegment();
                        this.clearActivePolygons();
                        return [4 /*yield*/, this.loadImage()];
                    case 2:
                        _b.sent();
                        this.applyGridSettings(gridState);
                        this.zone.runOutsideAngular(function () { return __awaiter(_this, void 0, void 0, function () {
                            var polygonMap, polygonId;
                            return __generator(this, function (_a) {
                                this.loadPolygons(polygons);
                                this.setClipboardPolygons(this.getPolygons(normalizedClipboardPolygons));
                                this.detectCollisions();
                                polygonMap = {};
                                this.getAllPolygons().forEach(function (p) { return (polygonMap[p.id] = p); });
                                for (polygonId in activePolygonsIndex_1) {
                                    if (polygonMap[polygonId]) {
                                        this.addActivePolygon(polygonMap[polygonId]);
                                    }
                                }
                                if (this.roi && hasROI) {
                                    this.drawROI(roiPoints);
                                    if (!roiWasChanged) {
                                        this.roi.markAsSaved();
                                    }
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        if (this.project) {
                            this.initialCenter = this.project.view.center;
                        }
                        this.ready = true;
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        throw err_2;
                    case 4:
                        if (this.project) {
                            zoom = this.project.view.zoom;
                            center = this.project.view.center.clone();
                            this.setZoom(zoom);
                            this.setCenter(center);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /*************************
     *  Collision Detection  *
     ************************/
    /**
     * Remove all collisions currently on the screen
     */
    CanvasProvider.prototype.removeAllCollisions = function () {
        this.getAllChildren()
            .slice(0)
            .forEach(function (polygon) {
            if (polygon.neuralaType == 'Collision') {
                polygon.remove();
            }
        });
        this.hasOverlaps = false;
    };
    /**
     * Checks whether or not two bounding boxes intersect
     */
    CanvasProvider.prototype.doBoundingBoxesIntersect = function (a, b) {
        return (a.topLeft.x <= b.bottomRight.x &&
            a.bottomRight.x >= b.topLeft.x &&
            a.topLeft.y <= b.bottomRight.y &&
            a.bottomRight.y >= b.topLeft.y);
    };
    /**
     * Check to see if we should detect collisions on two Polygons
     * We perform a number of checks to weed out any instances
     * where we know checking for intersections are not necessary
     * 1) Check if polygonA is polygonB, if so, return false
     * 2) Check if polygonA or polygonB are both of type "Polygon", if not return false
     * 3) Check if we have already calculated polygonA with polygonB, if so return false
     * (because we don't then need to do polygonB with polygonA)
     * 4) Check if the bounding boxs of polygonA and polygonB intersect. If so, there is a chance
     * that the polygons will intersect, though not guaranteed. If the bounding boxes do not intersect
     * there is no chance that the polygons will intersect, so we can safely ignore this combo.
     * 5) if polygons A and B are boundingboxes, that means that it is a detection workspace, and thus, dont check for collisions
     *
     * Ideas for Further Optimizations:
     * 1. Can we check to see if a polygon has been changed at all? If two polygons have not been
     * changed, maybe we can just cache their collision and not bother with computing intersection again.
     * 2. One day, it would be nice to give the martinez library a try again: https://github.com/w8r/martinez.
     * It was VERY fast, but it had enough bugs that we couldn't realistically rely on it in a production scenario,
     * but if they iron out enough of the bugs it would be great to use it again because performance could definitely improve.
     */
    CanvasProvider.prototype.shouldDetectCollisions = function (polygonA, polygonB, collisionsAlreadyComputed) {
        if (collisionsAlreadyComputed === void 0) { collisionsAlreadyComputed = {}; }
        var AB = polygonA.id.toString() + polygonB.id.toString();
        var BA = polygonB.id.toString() + polygonA.id.toString();
        if (!polygonA.closed ||
            !polygonB.closed ||
            polygonA.id == polygonB.id ||
            polygonA.neuralaType != 'Polygon' ||
            polygonB.neuralaType != 'Polygon' ||
            collisionsAlreadyComputed[AB] ||
            collisionsAlreadyComputed[BA] ||
            !this.doBoundingBoxesIntersect(polygonA.bounds, polygonB.bounds) ||
            polygonA.isBoundingBox ||
            polygonB.isBoundingBox) {
            return false;
        }
        collisionsAlreadyComputed[AB] = true;
        collisionsAlreadyComputed[BA] = true;
        return true;
    };
    CanvasProvider.prototype.getPolygonIntersection = function (polygonA, polygonB) {
        var clipperA = this.neuralaToClipper(polygonA);
        var clipperB = this.neuralaToClipper(polygonB);
        return this.getClipperIntersection(clipperA, clipperB);
    };
    CanvasProvider.prototype.getRectangleIntersection = function (polygon, area) {
        var clipperA = this.neuralaToClipper(polygon);
        var clipperB = this.rectangleToClipper(area);
        return this.getClipperIntersection(clipperA, clipperB);
    };
    CanvasProvider.prototype.getClipperIntersection = function (clipperA, clipperB) {
        var _this = this;
        var clipper = new ClipperLib.Clipper();
        var polytree = new ClipperLib.PolyTree();
        clipper.AddPaths(clipperA, ClipperLib.PolyType.ptSubject, true);
        clipper.AddPaths(clipperB, ClipperLib.PolyType.ptClip, true);
        clipper.Execute(ClipperLib.ClipType.ctIntersection, polytree, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        /**
         * Since ClipperLib uses ints internally, we need to scale our points
         * up and down to preserve the floating point values
         * As a result, there are sometimes floating point errors in calculating
         * collisions. This value is used to account for those and filter them out
         */
        return ClipperLib.JS.PolyTreeToExPolygons(polytree)
            .filter(function (polygon) {
            return ClipperLib.JS.AreaOfPolygon(polygon.outer) > _this.FLOATING_POINT_ERROR_THRESHOLD;
        })
            .map(function (polygon) {
            return _this.exPolygonToNeurala(polygon);
        });
    };
    CanvasProvider.prototype.getPolygonUnion = function (polygonA, polygonB) {
        var clipperA = this.neuralaToClipper(polygonA);
        var clipperB = this.neuralaToClipper(polygonB);
        return this.getClipperUnion(clipperA, clipperB);
    };
    CanvasProvider.prototype.getRectangleUnion = function (polygon, area) {
        var clipperA = this.neuralaToClipper(polygon);
        var clipperB = this.rectangleToClipper(area);
        return this.getClipperUnion(clipperA, clipperB);
    };
    CanvasProvider.prototype.getClipperUnion = function (clipperA, clipperB) {
        var _this = this;
        var clipper = new ClipperLib.Clipper();
        var polytree = new ClipperLib.PolyTree();
        clipper.AddPaths(clipperA, ClipperLib.PolyType.ptSubject, true);
        clipper.AddPaths(clipperB, ClipperLib.PolyType.ptClip, true);
        clipper.Execute(ClipperLib.ClipType.ctUnion, polytree, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        /**
         * Since ClipperLib uses ints internally, we need to scale our points
         * up and down to preserve the floating point values
         * As a result, there are sometimes floating point errors in calculating
         * collisions. This value is used to account for those and filter them out
         */
        return ClipperLib.JS.PolyTreeToExPolygons(polytree)
            .filter(function (polygon) {
            return ClipperLib.JS.AreaOfPolygon(polygon.outer) > _this.FLOATING_POINT_ERROR_THRESHOLD;
        })
            .map(function (polygon) {
            return _this.exPolygonToNeurala(polygon);
        });
    };
    /**
     * Detect any overlapping polygons and render them on the screen
     */
    CanvasProvider.prototype.detectCollisions = function () {
        var _this = this;
        this.removeAllCollisions();
        var currentPolygons = this.getAllChildren().slice(0);
        var collisionsAlreadyComputed = {};
        currentPolygons.forEach(function (polygonA) {
            currentPolygons.forEach(function (polygonB) {
                if (!_this.shouldDetectCollisions(polygonA, polygonB, collisionsAlreadyComputed)) {
                    return;
                }
                var polygons = _this.getPolygonIntersection(polygonA, polygonB);
                if (polygons.length > 0) {
                    _this.hasOverlaps = true;
                }
                polygons.forEach(function (polygon) {
                    // tslint:disable-next-line: no-unused-expression
                    new Collision({
                        children: polygon.map(function (layer) { return new paper.Path({ segments: layer, closed: true }); })
                    });
                });
            });
        });
        this.events.publish(EventName.CanvasOverlappingPolygons, this.hasOverlaps);
    };
    /**************************
     *  ClipperLib Utilities  *
     *************************/
    CanvasProvider.prototype.neuralaToClipper = function (polygon) {
        return polygon.children.map(function (item) {
            var paperPath = item;
            var toObject = paperPath.segments.map(function (segment) {
                return {
                    X: segment.point.x * 1000000,
                    Y: segment.point.y * 1000000
                };
            });
            toObject.push(toObject[0]);
            return toObject;
        });
    };
    CanvasProvider.prototype.rectangleToClipper = function (area) {
        var clipperResult = [];
        clipperResult.push({
            X: area.topLeft.x * 1000000,
            Y: area.topLeft.y * 1000000
        });
        clipperResult.push({
            X: area.topRight.x * 1000000,
            Y: area.topRight.y * 1000000
        });
        clipperResult.push({
            X: area.bottomRight.x * 1000000,
            Y: area.bottomRight.y * 1000000
        });
        clipperResult.push({
            X: area.bottomLeft.x * 1000000,
            Y: area.bottomLeft.y * 1000000
        });
        // This is not a typo, we need the clipper array to start and end with the same point to complete the polygon
        clipperResult.push({
            X: area.topLeft.x * 1000000,
            Y: area.topLeft.y * 1000000
        });
        return [clipperResult];
    };
    CanvasProvider.prototype.exPolygonToNeurala = function (exPolygon) {
        var contour = exPolygon.outer.map(function (point) { return new paper.Point(point.X / 1000000, point.Y / 1000000); });
        var layers = exPolygon.holes.map(function (hole) {
            return hole.map(function (point) { return new paper.Point(point.X / 1000000, point.Y / 1000000); });
        });
        layers.unshift(contour);
        return layers;
    };
    /**
     * Applies settings to the canvas and redraws it
     */
    CanvasProvider.prototype.applyWorkspaceSettings = function (settings) {
        var _this = this;
        var newSettings = Object.assign({
            labelsEnabled: this.labelsEnabled,
            noClassColor: this.noClassColor,
            predictionsEnabled: this.predictionsEnabled
        }, settings);
        this.labelsEnabled = newSettings.labelsEnabled;
        this.noClassColor = newSettings.noClassColor;
        this.predictionsEnabled = newSettings.predictionsEnabled;
        this.getAllPolygons().forEach(function (polygon) {
            polygon.setNoClassColor(_this.noClassColor);
            if (polygon.neuralaType == 'Polygon' || polygon.neuralaType == 'Collision') {
                polygon.visible = true;
                polygon.fullySelected = false;
            }
        });
    };
    /******************************
     *  Canvas Filter Management  *
     *****************************/
    /**
     * Update the filter string on the canvas object with the given values
     *
     * @return void
     */
    CanvasProvider.prototype.updateFilter = function (options) {
        var asset = this.asset;
        var currentFilterString = this.getCanvasContextFilter(asset);
        // split the current filter using the \w expression to map properties to values
        // WARNING: WILL NOT WORK WITH THE drop-shadow AND hue-rotate PROPERTIES
        var properties = currentFilterString.split(/[()\ ]/);
        // tslint:disable-next-line: prettier
        var oldBrightness = properties.indexOf('brightness') < 0 ? 1 : properties[properties.indexOf('brightness') + 1];
        var oldContrast = properties.indexOf('contrast') < 0 ? 1 : properties[properties.indexOf('contrast') + 1];
        asset.drawImage(asset.sourceRaster.canvas, new paper.Point(0, 0));
        // tslint:disable-next-line: prettier
        var filterString = "brightness(" + (options.brightness || oldBrightness) + ") contrast(" + (options.contrast || oldContrast) + ")";
        this.setCanvasContextFilter(asset, filterString);
        asset.drawImage(asset.canvas, new paper.Point(0, 0));
    };
    /**
     * Reset the current canvas filter to its original state. Sometimes the canvas will be an update behind, so we run this logic twice
     */
    CanvasProvider.prototype.resetFilter = function () {
        var asset = this.asset;
        asset.drawImage(asset.sourceRaster.canvas, new paper.Point(0, 0));
        this.setCanvasContextFilter(asset, 'brightness(100%) contrast(100%)');
        asset.drawImage(asset.canvas, new paper.Point(0, 0));
        asset.drawImage(asset.sourceRaster.canvas, new paper.Point(0, 0));
        this.setCanvasContextFilter(asset, 'brightness(100%) contrast(100%)');
        asset.drawImage(asset.canvas, new paper.Point(0, 0));
    };
    /**
     * Check if the unknown item is a bounding box, while first confirming
     * that it is a polygon.
     *
     * @param item The item we are checking against
     */
    CanvasProvider.prototype.safeIsBoundingBoxCheck = function (item) {
        if (item instanceof Polygon) {
            return item.isBoundingBox;
        }
        return false;
    };
    /**
     * Provide a single place to get the current showPixelDimensions setting with a sane default
     */
    CanvasProvider.prototype.shouldShowPixelDimensions = function () {
        return this.settingsProvider.get('detection.workspace.showPixelDimensions') === true;
    };
    /**
     * Returns a Rectangle which describes bounding box and a location of an asset on canvas.
     * The result is in "real" pixels.
     *
     * One of use-cases: marquee tool.
     * It is useful to check that the mouse is inside asset.
     * And it helps to calculate the size and location of guidelines.
     * The problem here is that we must use "real" pixels to define location and a size of a guideline
     * and we need to make sure that the mouse is moved over the assets. Our asset is drawn on canvas,
     * so it doesn't have normal boundaries as any other tag has and we must calculate them by ourself.
     */
    CanvasProvider.prototype.getAssetBoundingClientRect = function () {
        var canvas = this.getCanvas();
        var asset = this.getAsset();
        var project = this.getProject();
        if (!asset || !canvas || !project) {
            return;
        }
        var zoom = project.view.zoom;
        // To compute any dimension of an asset we see on the screen
        // we must use zoom and scaling of an assset
        var visibleWidth = asset.width * zoom * asset.scaling.x;
        var visibleHeight = asset.height * zoom * asset.scaling.y;
        var canvasWidth = canvas.width;
        var canvasHeight = canvas.height;
        var x = 0;
        var y = 0;
        var width = 0;
        var height = 0;
        var top = 0;
        var right = 0;
        var bottom = 0;
        var left = 0;
        // if zoomed in asset is wider then canvas
        // then our bounding rectangle's width is the same as our canvas
        if (visibleWidth > canvasWidth) {
            right = canvasWidth;
            x = 0;
            left = 0;
            width = canvasWidth;
        }
        else {
            // As for now we always place asset in the middle of the canvas
            x = (canvasWidth - visibleWidth) / 2;
            left = x;
            right = x + visibleWidth;
            width = visibleWidth;
        }
        // if zoomed in asset is taller then canvas
        // then our bounding rectangle's height is the same as our canvas
        if (visibleHeight > canvasHeight) {
            y = 0;
            top = 0;
            bottom = canvasHeight;
            height = canvasHeight;
        }
        else {
            // As for now we always place asset in the middle of the canvas
            y = (canvasHeight - visibleHeight) / 2;
            top = 0;
            bottom = y + visibleHeight;
            height = visibleHeight;
        }
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    CanvasProvider.prototype.getCanvasContextFilter = function (asset) {
        var canvasContext = this.getCanvasContext(asset);
        var canvasFilters = canvasContext;
        return canvasContext ? canvasFilters.filter || '' : '';
    };
    CanvasProvider.prototype.setCanvasContextFilter = function (asset, filter) {
        var canvasContext = this.getCanvasContext(asset);
        if (canvasContext) {
            var canvasFilters = canvasContext;
            canvasFilters.filter = filter;
        }
    };
    CanvasProvider.prototype.getCanvasContext = function (asset) {
        return asset.canvas.getContext('2d');
    };
    CanvasProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ClassProvider,
            ModalProvider,
            Events,
            NgZone,
            SettingsProvider,
            MuteableModalProvider,
            TranslateService])
    ], CanvasProvider);
    return CanvasProvider;
}(BaseProvider));
export { CanvasProvider };
//# sourceMappingURL=canvas.js.map


// WEBPACK FOOTER //
// ./src/providers/workspace/canvas.ts.pre-build-optimizer.js